import { h } from 'vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { format } from 'date-fns' 

export interface Config {
  id: number;
  name: string;
  value: string;
  configtype: string;
  created_at: Date;
  updated_at: Date;
}

export const colsconfig = [
  { key: "id", label: "ID", editable: false },
  { key: "name", label: "Name", type: 'text', editable: true, required: true },
  { key: "value", label: "Wert", type: 'text', editable: true, required: true },
  { key: "created_at", label: "Erzeugt", type: 'date', editable: false, required: true },
  { key: "updated_at", label: "Geändert", type: 'date', editable: false, required: true },
];
